import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom"; // Assuming you're using react-router for navigation
import { RiArrowDownSLine } from "react-icons/ri";
import {
  getRequest,
  putRequest,
  putWithFormData,
} from "../../helpers/api.helper";
import { StepPropsType } from "../../types";
import { useLanguage } from "../../context/LanguageContext";

const Step5 = ({
  bureauId,
  setCurrentStep,
  currentStep,
  steps,
  profileId,
  setCompletedSteps,
}: StepPropsType) => {
  const [modalData, setModalData] = useState<any>(null);
  const [searchTerm, setSearchTerm] = useState("");
  const { t } = useLanguage();
  const [modalData2, setModalData2] = useState<any>(null);
  const [searchTerm2, setSearchTerm2] = useState("");
  const [occupation, setOccupation] = useState([]);
  const [city, setCity] = useState([]);

  const [formData, setFormData] = useState({
    fatherEmployee: "",
    fatherOccupied: "",
    motherEmployee: "",
    motherOccupied: "",
    totalBrothers: "2", // Default to 2
    marriedBrothers: "",
    totalSisters: "2", // Default to 2
    marriedSisters: "",
    familyValue: "add_another", // Default to add another
    familyType: "nuclear", // Default to nuclear
    familyStatus: "", // New field for family status
    originalLocation: "",
    selectedLocation: "",

    youngerBrothers: "",
    elderBrothers: "",
    youngerSisters: "",
    elderSisters: "",
  });

  const [selectedOptions, setSelectedOptions] = useState<any>({
    servicePreference: null,
    imagePrivacy: null,
  });

  const [selectedOptions2, setSelectedOptions2] = useState<any>({
    Father_Employee: { value: "private_employee", label: "Private Employee" }, // Default to Private Employee
    Mother_Employee: { value: "not_employee", label: "Not Employee" }, // Default to Not Employee
  });

  const dropdownOptions: any = {
    Proper_Location: [
      ...city.map((caste: any) => ({ value: caste.city, label: caste.city })),
    ],
    Setteled_Location: [
      ...city.map((subcaste: any) => ({
        value: subcaste.city,
        label: subcaste.city,
      })),
    ],
  };

  const dropdownOptions2: any = {
    Father_Employee: [
      { value: "not_employee", label: "Not Employee" },
      { value: "govt_employee", label: "Govt Employee" },
      { value: "private_employee", label: "Private Employee" },
      { value: "business_owner", label: "Business Owner" },
      { value: "self_employe", label: "Self Employee" },
      { value: "farmer", label: "Farmer" },
      { value: "retired_employee", label: "Retired Employee" },
      { value: "expaired", label: "Expired" },
    ],

    Father_Occupation: [
      ...occupation.map((subcaste: any) => ({
        value: subcaste.occupation,
        label: subcaste.occupation,
      })),
    ],

    Mother_Employee: [
      { value: "not_employee", label: "Not Employee" },
      { value: "govt_employee", label: "Govt Employee" },
      { value: "private_employee", label: "Private Employee" },
      { value: "business_owner", label: "Business Owner" },
      { value: "self_employe", label: "Self Employee" },
      { value: "retired_employee", label: "Retired Employee" },
      { value: "expaired", label: "Expired" },
      { value: "home_maker", label: "Home Maker" },
    ],
    Mother_Occupation: [
      ...occupation.map((subcaste: any) => ({
        value: subcaste.occupation,
        label: subcaste.occupation,
      })),
    ],
    Family_Status: [
      { value: "poor_family", label: "Poor Family" },
      { value: "middle_class", label: "Middle Class" },
      { value: "upper_middle_class", label: "Upper Middle Class" },
      { value: "rich_family", label: "Rich Family" },
      { value: "ias_family", label: "IAS Family" },
      { value: "ips_family", label: "IPS Family" },
    ],
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getRequest("/common/profile/step5");
        setCity(response.data.city);
        setOccupation(response.data.occupation);
      } catch (error) {
        console.error(`Error fetching data:`, error);
      }
    };
    fetchData();
  }, []);
  const openModal = (key: any) => {
    setModalData({ key, options: dropdownOptions[key] });
  };

  const openModal2 = (key: any) => {
    setModalData2({ key, options: dropdownOptions2[key] });
  };

  const closeModal = () => {
    setModalData(null);
    setSearchTerm("");
  };

  const closeModal2 = () => {
    setModalData2(null);
    setSearchTerm2("");
  };

  const handleSelect = (selectedOption: any) => {
    setSelectedOptions({ ...selectedOptions, [modalData.key]: selectedOption });
    closeModal();
  };

  const handleSelect2 = (selectedOption: any) => {
    setSelectedOptions2({
      ...selectedOptions2,
      [modalData2.key]: selectedOption,
    });
    closeModal2();
  };

  // Handle form input change
  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // Generate options for Married Brothers/Sisters based on the selected total
  const generateOptions = (maxValue: any) => {
    return [...Array(maxValue + 1).keys()].map((i) => (
      <option key={i} value={i}>
        {i}
      </option>
    ));
  };

  useEffect(() => {
    if (!profileId) return;

    // Wait until master data is loaded
    if (!city.length || !occupation.length) return;

    const fetchStep5Data = async () => {
      try {
        const res = await getRequest(`/bureau/profile/${profileId.martialId}`);
        if (!res?.data) return;
        const data = res.data;
        setFormData((prev) => ({
          ...prev,
          totalBrothers: data.totalBrothers ?? prev.totalBrothers,
          marriedBrothers: data.marriedBrothers ?? "",
          totalSisters: data.totalSisters ?? prev.totalSisters,
          marriedSisters: data.marriedSisters ?? "",
          familyValue: data.familyValue ?? prev.familyValue,
          familyType: data.familyType ?? prev.familyType,
          familyStatus: data.familyStatus ?? "",
          youngerBrothers: data.youngerBrothers ?? "",
          elderBrothers: data.elderBrothers ?? "",
          youngerSisters: data.youngerSisters ?? "",
          elderSisters: data.elderSisters ?? "",
        }));
        setSelectedOptions((prev: any) => ({
          ...prev,
          Proper_Location: data.originalLocation
            ? { value: data.originalLocation, label: data.originalLocation }
            : prev.Proper_Location,

          Setteled_Location: data.selectedLocation
            ? { value: data.selectedLocation, label: data.selectedLocation }
            : prev.Setteled_Location,
        }));
        setSelectedOptions2((prev: any) => ({
          ...prev,

          Father_Employee: data.fatherEmployee
            ? dropdownOptions2.Father_Employee.find(
                (opt: any) => opt.value === data.fatherEmployee,
              ) || prev.Father_Employee
            : prev.Father_Employee,

          Father_Occupation: data.fatherOccupied
            ? { value: data.fatherOccupied, label: data.fatherOccupied }
            : prev.Father_Occupation,

          Mother_Employee: data.motherEmployee
            ? dropdownOptions2.Mother_Employee.find(
                (opt: any) => opt.value === data.motherEmployee,
              ) || prev.Mother_Employee
            : prev.Mother_Employee,

          Mother_Occupation: data.motherOccupied
            ? { value: data.motherOccupied, label: data.motherOccupied }
            : prev.Mother_Occupation,

          Family_Status: data.familyStatus
            ? dropdownOptions2.Family_Status.find(
                (opt: any) => opt.value === data.familyStatus,
              )
            : prev.Family_Status,
        }));
      } catch (err) {
        console.error("Failed to load Step5 data", err);
      }
    };

    if (bureauId) fetchStep5Data();
  }, [profileId, city.length, occupation.length]);

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    const formattedOptions = {
      originalLocation: selectedOptions.Proper_Location?.value || "",
      selectedLocation: selectedOptions.Setteled_Location?.value || "",
    };
    const formattedOptions2 = {
      fatherEmployee: selectedOptions2.Father_Employee?.value || "",
      fatherOccupied: selectedOptions2.Father_Occupation?.value || "",
      motherEmployee: selectedOptions2.Mother_Employee?.value || "",
      motherOccupied: selectedOptions2.Mother_Occupation?.value || "",
    };
    const formDataToSend = {
      totalBrothers: formData.totalBrothers,
      marriedBrothers: formData.marriedBrothers,
      totalSisters: formData.totalSisters,
      marriedSisters: formData.marriedSisters,
      familyValue: formData.familyValue,
      familyType: formData.familyType,
      familyStatus: formData.familyStatus, // Add family status
      youngerBrothers: formData.youngerBrothers,
      elderBrothers: formData.elderBrothers,
      youngerSisters: formData.youngerSisters,
      elderSisters: formData.elderSisters,
      ...formattedOptions,
      ...formattedOptions2,

      // Including previously existing fields
      step1: 1,
      step2: 1,
      step3: 1,
      step4: 1,
      step5: 1, // You can modify this flag to indicate step 5 completion
    };

    try {
      //Send the PUT request to update the data
      const response = await putRequest(
        `/bureau/profile/${profileId?.userId}`,
        formDataToSend,
      );

      if (response.success) {
        setCompletedSteps?.((prev) =>
          prev.includes(currentStep) ? prev : [...prev, currentStep],
        );
        if (currentStep < steps.length) {
          setCurrentStep(currentStep + 1);
        }
      } else {
        alert("Failed to update details.");
      }
    } catch (error) {
      console.error("Error updating details:", error);
    }
  };

  const customStyles = {
    control: (provided: any) => ({
      ...provided,
      width: "100%",
      padding: "0.75rem",
      borderRadius: "0.375rem",
      border: "1px solid #c4d4e2",
    }),
    menu: (provided: any) => ({
      ...provided,
      backgroundColor: "#ffffff",
      zIndex: 9999,
      border: "",
    }),
    menuList: (provided: any) => ({
      ...provided,
      padding: 0, // Remove extra padding
      boxShadow: "0 20px 20px rgba(0, 0, 0, 0.9)", // Example box-shadow
      border: "2px solid #000000",
      borderRadius: "20px ",
    }),
    option: (provided: any, state: any) => ({
      ...provided, // Add underline
      padding: "0.75rem", // Ensure enough padding for readability
      backgroundColor: state.isFocused ? "#f0f8ff" : "#ffffff", // Highlight on hover
      color: "#000", // Text color
      cursor: "pointer", // Change cursor on hover

      borderBottom: "1px solid #c4d4e2",
      borderRadius: "13px",
    }),
  };
  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls the page to the top
  }, []);

  return (
    <div className="w-full max-w-lg bg-white shadow-lg rounded-lg">
      <div className="flex flex-col gap-6  py-4 px-3">
        {/* Father Employee */}
        {Object.keys(dropdownOptions2).map((key) => {
          // Skip Father_Occupation if Father_Employee is not employed/retired/expired
          if (
            key === "Father_Occupation" &&
            selectedOptions2.Father_Employee?.value &&
            ["not_employee", "retired_employee", "expaired"].includes(
              selectedOptions2.Father_Employee.value,
            )
          ) {
            return null;
          }

          // Skip Mother_Occupation if Mother_Employee is not employed/retired/expired/home_maker
          if (
            key === "Mother_Occupation" &&
            selectedOptions2.Mother_Employee?.value &&
            [
              "not_employee",
              "retired_employee",
              "expaired",
              "home_maker",
            ].includes(selectedOptions2.Mother_Employee.value)
          ) {
            return null;
          }

          return (
            <>
              <div className="mb-[-20px]">
                <label className="block text-red-500 font-medium mb-2">
                  {t(key.replace(/_/g, " "))}
                </label>
              </div>

              <div
                key={key}
                className="flex flex-col w-full border px-3 border-gray-300 py-3 rounded-lg cursor-pointer hover:shadow-lg transition-all"
                onClick={() => openModal2(key)}
              >
                <div className="flex items-center justify-between rounded-lg">
                  <span className="text-gray-500 text-md ">
                    {selectedOptions2[key]?.label || `Select ${key}`}
                  </span>
                  <RiArrowDownSLine className="text-3xl text-gray-300 ml-3" />
                </div>
              </div>
            </>
          );
        })}

        <div>
          {/* Total Brothers */}
          <div>
            <label
              htmlFor="totalBrothers"
              className="text-red-500 font-medium mb-2"
            >
              {t("total_brothers")}
            </label>
            <select
              name="totalBrothers"
              value={formData.totalBrothers || ""}
              className="border border-gray-200 p-2 py-4 rounded-md mt-4 text-gray-600 w-full"
              // @ts-ignore
              styles={customStyles}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  totalBrothers: e.target.value,
                  youngerBrothers: "",
                  elderBrothers: "",
                  marriedBrothers: "", // Clear dependent fields
                })
              }
            >
              <option value="">Select Total Brothers</option>
              <option value="0">No Brothers</option>
              {[...Array(10).keys()].map((i) => (
                <option key={i + 1} value={i + 1}>
                  {i + 1}
                </option>
              ))}
            </select>
          </div>

          {/* Younger and Elder Brothers */}
          {formData.totalBrothers && formData.totalBrothers !== "0" && (
            <>
              <div className="mt-4">
                <label
                  htmlFor="youngerBrothers"
                  className="text-red-500 font-medium mb-2"
                >
                  {t("number_of_younger_brothers")}
                </label>
                <select
                  id="youngerBrothers"
                  name="youngerBrothers"
                  value={formData.youngerBrothers}
                  onChange={handleChange}
                  className="w-full p-4 border border-[#c4d4e2] rounded-md focus:outline-none focus:ring-2 focus:ring-[#c4d4e2] bg-white"
                >
                  <option value="">Select</option>
                  {generateOptions(parseInt(formData.totalBrothers))}
                </select>
              </div>

              <div className="mt-4">
                <label
                  htmlFor="elderBrothers"
                  className="text-red-500 font-medium mb-2"
                >
                  {t("number_of_elder_brothers")}
                </label>
                <select
                  id="elderBrothers"
                  name="elderBrothers"
                  value={formData.elderBrothers}
                  onChange={handleChange}
                  className="w-full p-4 border border-[#c4d4e2] rounded-md focus:outline-none focus:ring-2 focus:ring-[#c4d4e2] bg-white"
                >
                  <option value="">Select</option>
                  {generateOptions(parseInt(formData.totalBrothers))}
                </select>
              </div>

              <div className="mt-4">
                <label
                  htmlFor="marriedBrothers"
                  className="text-red-500 font-medium mb-2"
                >
                  {t("Married Brothers")}
                </label>
                <select
                  id="marriedBrothers"
                  name="marriedBrothers"
                  value={formData.marriedBrothers}
                  onChange={handleChange}
                  className="w-full p-4 border border-[#c4d4e2] rounded-md focus:outline-none focus:ring-2 focus:ring-[#c4d4e2] bg-white"
                >
                  <option value="">Select</option>
                  {generateOptions(parseInt(formData.totalBrothers))}
                </select>
              </div>
            </>
          )}

          {/* Total Sisters */}
          <div className="mt-6">
            <label
              htmlFor="totalSisters"
              className="text-red-500 font-medium mb-2"
            >
              {t("total_sisters")}
            </label>
            <select
              name="totalBrothers"
              value={formData.totalSisters || ""}
              className="border border-gray-200 p-2 py-4 rounded-md mt-4 text-gray-600 w-full"
              //@ts-ignore
              styles={customStyles}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  totalSisters: e.target.value,
                  youngerBrothers: "",
                  elderBrothers: "",
                  marriedBrothers: "", // Clear dependent fields
                })
              }
            >
              <option value="">Select Total Sisters</option>
              <option value="0">No Sisters</option>
              {[...Array(10).keys()].map((i) => (
                <option key={i + 1} value={i + 1}>
                  {i + 1}
                </option>
              ))}
            </select>
          </div>

          {/* Younger and Elder Sisters */}
          {formData.totalSisters && formData.totalSisters !== "0" && (
            <>
              <div className="mt-4">
                <label
                  htmlFor="youngerSisters"
                  className="text-red-500 font-medium mb-2"
                >
                  {t("number_of_younger_sisters")}
                </label>
                <select
                  id="youngerSisters"
                  name="youngerSisters"
                  value={formData.youngerSisters}
                  onChange={handleChange}
                  className="w-full p-4 border border-[#c4d4e2] rounded-md focus:outline-none focus:ring-2 focus:ring-[#c4d4e2] bg-white"
                >
                  <option value="">Select</option>
                  {generateOptions(parseInt(formData.totalSisters))}
                </select>
              </div>

              <div className="mt-4">
                <label
                  htmlFor="elderSisters"
                  className="text-red-500 font-medium mb-2"
                >
                  {t("number_of_elder_sisters")}
                </label>
                <select
                  id="elderSisters"
                  name="elderSisters"
                  value={formData.elderSisters}
                  onChange={handleChange}
                  className="w-full p-4 border border-[#c4d4e2] rounded-md focus:outline-none focus:ring-2 focus:ring-[#c4d4e2] bg-white"
                >
                  <option value="">Select</option>
                  {generateOptions(parseInt(formData.totalSisters))}
                </select>
              </div>

              <div className="mt-4">
                <label
                  htmlFor="marriedSisters"
                  className="text-red-500 font-medium mb-2"
                >
                  {t("Married Sisters")}
                </label>
                <select
                  id="marriedSisters"
                  name="marriedSisters"
                  value={formData.marriedSisters}
                  onChange={handleChange}
                  className="w-full p-4 border border-[#c4d4e2] rounded-md focus:outline-none focus:ring-2 focus:ring-[#c4d4e2] bg-white"
                >
                  <option value="">Select</option>
                  {generateOptions(parseInt(formData.totalSisters))}
                </select>
              </div>
            </>
          )}
        </div>

        {/* Family Value */}
        {/* Family Value */}
        <div>
          <label
            htmlFor="familyValue"
            className="text-red-500 font-medium mb-2"
          >
            {t("family_value")}
          </label>
          <select
            name="familyValue"
            className="border border-gray-200 p-2 py-4 rounded-md mt-4 text-gray-600 w-full"
            value={formData.familyValue || ""}
            onChange={(e) =>
              setFormData({
                ...formData,
                familyValue: e.target.value, // Update selected value
              })
            }
          >
            <option value="">Select Family Value</option>
            <option value="orthodox">Orthodox</option>
            <option value="traditional">Traditional</option>
            <option value="moderate">Moderate</option>
            <option value="liberal">Liberal</option>
            <option value="add_another">Add Another</option>
          </select>
        </div>

        {/* Family Type */}
        <div>
          <label htmlFor="familyType" className="text-red-500 font-medium mb-2">
            {t("family_type")}
          </label>
          <select
            name="familyType"
            className="border border-gray-200 p-2 py-4 rounded-md mt-4 text-gray-600 w-full"
            value={formData.familyType || ""}
            onChange={(e) =>
              setFormData({
                ...formData,
                familyType: e.target.value, // Update selected value
              })
            }
          >
            <option value="">Select Family Type</option>
            <option value="joint">Joint</option>
            <option value="nuclear">Nuclear</option>
          </select>
        </div>

        {Object.keys(dropdownOptions).map((key) => (
          <>
            <div className="mb-[-20px]">
              <label className="block text-red-500 font-medium mb-2">
                {t(key.replace(/_/g, " "))}
              </label>
            </div>

            <div
              key={key}
              className="flex flex-col w-full border px-3 border-gray-300 py-3 rounded-lg cursor-pointer hover:shadow-lg transition-all"
              onClick={() => openModal(key)}
            >
              <div className="flex items-center justify-between rounded-lg">
                <span className="text-gray-500 text-md ">
                  {selectedOptions[key]?.label || `Select ${key}`}
                </span>
                <RiArrowDownSLine className="text-3xl text-gray-300 ml-3" />
              </div>
            </div>
          </>
        ))}

        {/* <button
          type="submit"
          className="w-full mt-4 px-6 py-3 bg-red-600 text-white rounded-lg font-medium text-lg focus:outline-none hover:bg-red-700"
        >
          Submit
        </button> */}
        {/* Action Buttons */}
        <div className="flex flex-col-reverse sm:flex-row gap-3 pt-6">
          {/* <button
            onClick={() => {
              setCurrentStep(Math.max(1, currentStep - 1));
            }}
            className="flex-1 px-6 py-3.5 border-2 border-gray-300 text-gray-700 rounded-lg font-semibold hover:bg-gray-50 transition-colors"
          >
            Previous
          </button> */}
          <button
            onClick={handleSubmit}
            className="flex-1 px-6 py-3.5 bg-gradient-to-r from-pink-500 to-purple-600 text-white rounded-lg font-semibold hover:from-pink-600 hover:to-purple-700 transition-all shadow-lg"
          >
            {currentStep === steps.length ? t("Submit") : t("Next Step")}
          </button>
        </div>
      </div>
      {modalData && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-lg max-w-md w-full shadow-lg m-5">
            <h2 className="text-lg font-bold mb-4 capitalize text-center">
              {t("Select")} {t(modalData.key)}
            </h2>

            {/* Search Bar */}
            <input
              type="text"
              className="w-full px-4 py-2 mb-4 border border-gray-300 rounded focus:outline-none focus:ring focus:ring-blue-200"
              placeholder={`Search ${modalData.key}`}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />

            {/* Options List */}
            <div className="h-64 overflow-y-auto border-t border-b border-gray-200">
              {modalData.options
                .filter((option: any) =>
                  option.label.toLowerCase().includes(searchTerm.toLowerCase()),
                )
                .map((option: any, index: any) => (
                  <div key={index}>
                    <button
                      className="block w-full text-left px-4 py-2 hover:bg-gray-100 transition"
                      onClick={() => handleSelect(option)}
                    >
                      {option.label}
                    </button>
                    <hr className="border-gray-200 mt-3 mb-3" />
                  </div>
                ))}
            </div>

            {/* Close Button */}
            <button
              className="mt-4 w-full px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 transition"
              onClick={closeModal}
            >
              {t("Continue")}
            </button>
          </div>
        </div>
      )}

      {/* Modal 2 */}
      {modalData2 && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-lg max-w-md w-full shadow-lg m-5">
            <h2 className="text-lg font-bold mb-4 capitalize text-center">
              {t("Select")} {t(modalData2.key)}
            </h2>

            {/* Search Bar */}
            <input
              type="text"
              className="w-full px-4 py-2 mb-4 border border-gray-300 rounded focus:outline-none focus:ring focus:ring-blue-200"
              placeholder={`Search ${modalData2.key}`}
              value={searchTerm2}
              onChange={(e) => setSearchTerm2(e.target.value)}
            />

            {/* Options List */}
            <div className="h-64 overflow-y-auto border-t border-b border-gray-200">
              {modalData2.options
                .filter((option: any) =>
                  option.label
                    .toLowerCase()
                    .includes(searchTerm2.toLowerCase()),
                )
                .map((option: any, index: any) => (
                  <div key={index}>
                    <button
                      className="block w-full text-left px-4 py-2 hover:bg-gray-100 transition"
                      onClick={() => handleSelect2(option)}
                    >
                      {option.label}
                    </button>
                    <hr className="border-gray-200 mt-3 mb-3" />
                  </div>
                ))}
            </div>

            {/* Close Button */}
            <button
              className="mt-4 w-full px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 transition"
              onClick={closeModal2}
            >
              {t("Continue")}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Step5;
